import { z } from "zod";

export const tenantSchema = z.object({
  tenantId: z.string(),
  name: z.string(),
  status: z.string().optional(),
  // nullish (nullable + optional) — the API may send explicit null for these,
  // which .optional() alone would reject (safeValidate then silently passes the
  // raw value through). See useTrialStatus, which treats null/undefined alike.
  licenseType: z.string().nullish(),
  expiresAt: z.number().nullish(),
});

export const tenantsResponseSchema = z.object({
  tenants: z.array(tenantSchema),
  primaryTenantId: z.string(),
});

export const selectTenantResponseSchema = z.object({
  success: z.boolean(),
  idToken: z.string().nullable().optional(),
  accessToken: z.string(),
  refreshToken: z.string(),
  challengeName: z.string().nullable().optional(),
  session: z.string().nullable().optional(),
  message: z.string().nullable().optional(),
  tenants: z.array(z.unknown()).optional(),
  selectedTenantId: z.string(),
});

export type Tenant = z.infer<typeof tenantSchema>;
export type TenantsResponse = z.infer<typeof tenantsResponseSchema>;
export type SelectTenantResponse = z.infer<typeof selectTenantResponseSchema>;
